import React from "react"
import tw, { styled } from "twin.macro"

const MenuItem = styled.span`
  ${tw`py-2 mr-4 font-body w-full m:w-auto text-center m:text-left whitespace-nowrap relative inline-block`}
  font-size: 16px;
  letter-spacing: 0.4px;

  &:after {
    ${tw`bg-neonred`}
    content: "";
    position: absolute;
    bottom: 7px;
    width: 0px;
    height: 2px;
    margin: 0;
    transition: all 0.2s ease-in-out;
    opacity: 0;
    left: 0;
  }

  &:hover,
  &.active {
    color: #ffffff;

    &:after {
      width: 100%;
      opacity: 1;
    }
  }

  &.product {
    ${tw`text-white`}

    font-size: 14px;

    &:hover {
      color: #ffffff;
    }
  }
`

export default MenuItem
